import store from '@/masteradmin/store'

import {
  ACTION_GET_USER,
  ACTION_GET_NOTIFICATION,
} from '@/masteradmin/store/actions'
import { PAGE_LOGIN } from '@/masteradmin/router/routeNames'
import { isMasterAdmin } from 'globalUtils/isAdmin'

export default {
  beforeRouteEnter(to, from, next) {
    if (to.name === PAGE_LOGIN || store.state.user.isAuthenticated) {
      if (store.state.user.isAuthenticated) {
        store.dispatch(ACTION_GET_NOTIFICATION)
      }
      next()
    } else {
      store.dispatch(ACTION_GET_USER)
        .then(() => {
          if (
            store.state.user.isAuthenticated
            && isMasterAdmin(store.state.user.user)
          ) {
            store.dispatch(ACTION_GET_NOTIFICATION)
            next()
          } else {
            next({ name: PAGE_LOGIN })
          }
        }, () => {
          next({ name: PAGE_LOGIN })
        })
    }
  },
}



// WEBPACK FOOTER //
// ./client/masteradmin/mixins/masterAdminAccess.js